import { useEffect, useState } from 'react';
import StatusBadge from '../components/StatusBadge';
import { EtatVide } from '../components/EtatListe';
import { Bouton, BoutonTheme, ControleSegmente, Icone } from '../components/ui';
import { getCommandesDelavage, getArrivagesDelavage, ouvrirSessionDelavage, getCommandesFinition, getArrivagesFinition, ouvrirSessionFinition } from '../api/measurementApi';
import { FLOWS, flowsDisponibles } from '../flows';
import useBreakpoint from '../utils/useBreakpoint';
import ConfectionDrilldown from './drilldown/ConfectionDrilldown';
import CommandeArrivageDrilldown from './drilldown/CommandeArrivageDrilldown';
import { ACCENT, ACCENT_FOND, AMBRE, FOND_APP, SEPARATEUR, TEXTE, VERT } from '../theme';

export default function ListeScreen({ roles, nomAffiche, onLogout, onOuvrirSession, enLigne, enAttente }) {
  const flows = flowsDisponibles(roles);
  const [flowActif, setFlowActif] = useState(flows[0]?.cle || null);
  const { compact } = useBreakpoint();

  useEffect(() => {
    if (!flowActif && flows.length > 0) setFlowActif(flows[0].cle);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [roles]);

  const initiales = (nomAffiche || '?')
    .split(' ')
    .map((m) => m[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);

  const marge = compact ? 16 : 28;

  return (
    // Une seule zone de défilement : la barre du haut est un matériau translucide collé en tête,
    // sous lequel le contenu passe au lieu de s'arrêter net contre un bandeau opaque.
    <div style={{ height: '100dvh', overflow: 'auto', background: FOND_APP, color: TEXTE }}>
      <div
        className="aqs-materiau"
        style={{
          position: 'sticky', top: 0, zIndex: 20, borderBottom: `0.5px solid ${SEPARATEUR}`,
          minHeight: 64, display: 'flex', alignItems: 'center', gap: compact ? 10 : 14, flexWrap: 'wrap',
          padding: `8px ${marge}px`,
        }}
      >
        <img className="aqs-logo" src={process.env.PUBLIC_URL + '/logo-horizontal.png'} alt="Groupe SIP" style={{ flex: 'none', height: compact ? 30 : 36, width: 'auto', objectFit: 'contain' }} />
        <div style={{ flex: 1, minWidth: 0 }} />
        <StatusBadge
          point={enLigne ? VERT : AMBRE}
          texte={enLigne ? 'En ligne' : `Hors ligne${enAttente ? ` · ${enAttente} en attente` : ''}`}
          style={{ flex: 'none' }}
        />
        <BoutonTheme />
        <div style={{ flex: 'none', display: 'flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
          <div title={nomAffiche || 'Utilisateur'} style={{ flex: 'none', width: 36, height: 36, borderRadius: '50%', background: ACCENT_FOND, display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 650, fontSize: 14, color: ACCENT }}>{initiales}</div>
          {/* Le nom complet cède la place au badge réseau sur une tablette de 800 px : l'avatar et
              son `title` portent la même information. */}
          {!compact && (
            <div style={{ minWidth: 0, maxWidth: 220, fontSize: 15, fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{nomAffiche || 'Utilisateur'}</div>
          )}
          <Bouton variante="texte" onClick={onLogout} icone={<Icone.Sortie taille={20} />} aria-label="Déconnexion" style={{ padding: compact ? 0 : '0 10px' }}>
            {!compact && 'Déconnexion'}
          </Bouton>
        </div>
      </div>

      <div style={{ width: '100%', maxWidth: 1400, margin: '0 auto', padding: `20px ${marge}px 40px` }}>
        {flows.length > 1 && (
          <ControleSegmente
            options={flows.map((f) => ({ valeur: f.cle, libelle: f.titre }))}
            valeur={flowActif}
            onChange={setFlowActif}
            hauteur={44}
            style={{ maxWidth: compact ? '100%' : 640, marginBottom: 24 }}
          />
        )}

        {flows.length === 0 && (
          <EtatVide texte="Votre compte ne porte aucun rôle de saisie de mesure (confection, délavage ou finition). Contactez la direction si c'est inattendu." />
        )}

        {/* `key` sur le volet : changer de volet repart du premier niveau, avec un simple fondu. */}
        <div key={flowActif} className="aqs-nav-fondu">
          {flowActif === FLOWS.CONFECTION.cle && (
            <ConfectionDrilldown onSessionOuverte={(sessionId, contexte) => onOuvrirSession(sessionId, contexte)} />
          )}
          {flowActif === FLOWS.DELAVAGE.cle && (
            <CommandeArrivageDrilldown
              titreNiveau1="Réception délavage"
              sousTitreNiveau1="Choisissez la commande dont vous mesurez la réception."
              chargerCommandes={getCommandesDelavage}
              chargerArrivages={getArrivagesDelavage}
              ouvrirSession={ouvrirSessionDelavage}
              champId="receptionDelavageId"
              onSessionOuverte={(sessionId, contexte) => onOuvrirSession(sessionId, contexte)}
            />
          )}
          {flowActif === FLOWS.FINITION.cle && (
            <CommandeArrivageDrilldown
              titreNiveau1="Finition"
              sousTitreNiveau1="Choisissez la commande dont vous mesurez la réception après délavage."
              chargerCommandes={getCommandesFinition}
              chargerArrivages={getArrivagesFinition}
              ouvrirSession={ouvrirSessionFinition}
              champId="receptionId"
              onSessionOuverte={(sessionId, contexte) => onOuvrirSession(sessionId, contexte)}
            />
          )}
        </div>
      </div>
    </div>
  );
}
